import { formatDate } from 'helpers/DateFormatter';

function getMoNumberField(selectedTag, formData, formDataSRA, isNonMoFeatureEnabled, IsLateEntry, handleTagBlur) {
    if (isNonMoFeatureEnabled || IsLateEntry) {
        return {
            key: 'F20Mo',
            label: 'MO Number',
            value: formData?.F20Mo ?? selectedTag?.HdWorkOrder ?? formDataSRA?.F20Mo,
            labelWidth: '26%',
            borderTop: '0',
            marginBottom: '5px',
            maxLength: '15',
            width: '60%',
            type: 'integer',
            xs: 4,
            readOnly: !!selectedTag?.HdLocation,
            isRequired: !!IsLateEntry,
            ...(IsLateEntry && { handleBlur: handleTagBlur })
        };
    }
    return {
        key: 'Nodata',
        label: '',
        value: '',
        xs: 4,
        readOnly: true,
    };
}

export const UserInfoSectionData = (selectedTag, userName, formData, formDataSRA, isNonMoFeatureEnabled, IsLateEntry, handleTagBlur) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'F2SapFloc',
                label: 'Tag Number',
                value: formData.F2SapFloc ?? selectedTag?.HdLocation ?? formDataSRA?.F2SapFloc,
                labelWidth: '26%',
                marginBottom: '0px',
                width: '60%',
                isRequired: true,
                maxLength: '30',
                xs: 4,
                readOnly: !!selectedTag?.HdLocation,
                ...(IsLateEntry && { handleBlur: handleTagBlur })
            },
            {
                key: 'F4CompletedBy',
                label: 'Created By',
                value: formData?.F4CompletedBy ?? userName?.name,
                labelWidth: '26%',
                xs: 4,
                readOnly: true
            },
            {
                key: 'F5DateTested',
                label: 'Created Date',
                value: formData.F5DateTested ?? selectedTag.DateTested
                    ? formatDate(new Date(formData.F5DateTested ?? selectedTag.DateTimeTested))
                    : formatDate(selectedTag.currentDateTime),
                labelWidth: '29%',
                xs: 4,
                readOnly: true
            },
            getMoNumberField(selectedTag, formData, formDataSRA, isNonMoFeatureEnabled, IsLateEntry, handleTagBlur),
            {
                key: 'F4ModifiedBy',
                label: 'Modified By',
                value: formData.F4ModifiedBy,
                labelWidth: '26%',
                xs: 4,
                readOnly: true
            },
            {
                key: 'F51DateLastModified',
                label: 'Last Modified Date',
                value: formData.F51DateLastModified ? formatDate(new Date(formData.F51DateLastModified)) : '',
                labelWidth: '29%',
                xs: 4,
                readOnly: true
            },
            {
                key: 'F731Doc1Url',
                label: 'Document 1 URL',
                value: selectedTag.DateTested ? formData?.F731Doc1Url : formData?.F731Doc1Url ?? selectedTag?.Doc1Url,
                width: '82%',
                labelWidth: '13%',
                textalign: 'left',
                xs: 8,
                wordBreak: true,
                readOnly: true
            },
            {
                key: 'F729Doc1Number',
                label: 'Document 1 Number',
                value: selectedTag.DateTested ? formData?.F729Doc1Number : formData?.F729Doc1Number ?? selectedTag?.Doc1Number,
                width: '65%',
                labelWidth: '29%',
                xs: 4,
                borderTop: '0',
                marginBottom: '15px',
                wordBreak: true,
                readOnly: true
            },
            {
                key: 'F732Doc2Url',
                label: 'Document 2 URL',
                value: selectedTag.DateTested ? formData?.F732Doc2Url : formData?.F732Doc2Url ?? selectedTag?.Doc2Url,
                width: '82%',
                labelWidth: '13%',
                marginBottom: '15px',
                textalign: 'left',
                xs: 8,
                wordBreak: true,
                readOnly: true
            },
            {
                key: 'F730Doc2Number',
                label: 'Document 2 Number',
                value: selectedTag.DateTested ? formData?.F730Doc2Number : formData?.F730Doc2Number ?? selectedTag?.Doc2Number,
                marginLeft: '2rem',
                width: '65%',
                labelWidth: '29%',
                xs: 4,
                borderTop: '0',
                marginBottom: '15px',
                wordBreak: true,
                readOnly: true
            },
            ]
        }
    ]
});
